module.exports = __webpack_public_path__ + "static/img/8302_phase_function_Paper_PointsHejduk_Prediction.153241d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8302_phase_function_Paper_PointsHejduk_Prediction.png
// module id = KNqC
// module chunks = 0